import { useQuery } from "@tanstack/react-query";
import { fetchCampaignAnalytics } from "@/api/campaigns";

export function useCampaignAnalytics(campaignId: string) {
  return useQuery({
    queryKey: ["campaignAnalytics", campaignId],
    queryFn: () => fetchCampaignAnalytics(campaignId),
    enabled: !!campaignId,
  });
}
